import { Component, HostListener, OnInit, inject } from '@angular/core'
import { FormGroup } from '@angular/forms'
import { Router } from '@angular/router'
import { RoutePaths } from 'src/app/core/data/route-paths.data'
import { ConfigurablePageComponent } from 'src/app/core/abstracts/configurable-page.component'
import { IAsset } from 'src/app/core/interfaces/asset.interface'
import { EventService } from 'src/app/core/services/event.service'
import { GlobalDataService } from 'src/app/core/services/global-data.service'
import { SeoService } from 'src/app/core/services/seo.service'

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['../../../assets/page.scss', './home.component.scss'],
  providers: [SeoService],
  standalone: false,
})
export class HomeComponent extends ConfigurablePageComponent implements OnInit {
  private _router = inject(Router)
  private _seoService = inject(SeoService)
  private _eventService = inject(EventService)
  protected globalData = inject(GlobalDataService)

  contactForm = new FormGroup({})

  ngOnInit() {
    const config = this.globalDataService.config()
    this.pageConfig.set(config.page.home)
    this._seoService.init(
      config.seo.data,
      this.pageConfig().seo.data,
    )
  }

  cardClicked(assetId: string) {
    this._router.navigate([RoutePaths.Details, assetId])
  }

  contactClicked(asset: IAsset) {
    this._eventService.notify('contactClicked', asset)
  }
}
